/**
 * Created by andrey on 14.09.2022
 */

const PaymentOverlay = cc.Scale9Sprite.extend({
    ctor: function () {
        this.openedAt = Date.now();
        this._super(bundles.pixel.frames.pixel_png);

        this.alwaysOn = true;

        this.setColor(cleverapps.styles.COLORS.BLACK);
        this.setLocalZOrder(Transition.ZORDER + 1);

        cleverapps.UI.onClick(this, () => {
            if (this.closeText.isVisible()) {
                this.startCancel();
            }
        }, {
            interactiveScale: false,
            swallowEvents: true
        });

        this.createText();
        this.createCloseText();
        this.showLoading();

        this.onResize();

        // the text follows the purchase: the store is slow after SLOW_TIMEOUT, our server is validating once the store answered
        this.schedule(this.refreshText.bind(this), 0.5);

        this.setOpacity(0);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(PaymentOverlay.SHOW_TIMEOUT / 1000),
            new cc.CallFunc(() => {
                this.hideLoading();
            }),
            new cc.FadeTo(0.3, 150)
        ));
    },

    showLoading: function () {
        const loading = this.loading = new LoadingAnimation();
        loading.setAlignment(this.width / 2, this.height / 2);
        this.addChild(loading);

        loading.setVisible(false);
        loading.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.Show()
        ));
    },

    hideLoading: function () {
        if (this.loading) {
            this.loading.removeFromParent();
            delete this.loading;
        }
    },

    onResize: function () {
        const styles = cleverapps.styles.PaymentOverlay;

        const bgSize = cleverapps.resolution.getBgSize();
        const safePadding = cleverapps.resolution.getSafePadding();
        this.setContentSize2(bgSize.width, bgSize.height);
        this.setAnchorPoint(0.5, 0.5);
        this.setAlignment(bgSize.width / 2 - safePadding.left, bgSize.height / 2 - safePadding.bottom);

        if (this.loading) {
            this.loading.setAlignment(this.width / 2, this.height / 2);
        }

        if (this.text) {
            this.textWidth = this.width - styles.text.padding * 2;
            this.text.setDimensions(this.textWidth, 0);
            this.text.fitTo(this.textWidth);
            this.text.setAlignment({
                x: styles.text.x,
                y: { align: "bottom", dy: styles.text.y.dy + safePadding.bottom }
            });
        }

        if (this.closeText) {
            this.closeText.setDimensions(this.width, 0);
            this.closeText.fitTo(this.width);
            this.closeText.setAlignment({
                x: styles.closeText.x,
                y: { align: "bottom", dy: styles.closeText.y.dy + safePadding.bottom }
            });
        }
    },

    createText: function () {
        const text = this.text = cleverapps.UI.generateOnlyText(Messages.get("PaymentOverlay.waiting"), cleverapps.styles.FONTS.PAYMENT_OVERLAY_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setAnchorPoint(0.5, 0);
        this.addChild(text);

        text.setOpacity(0);
        text.runAction(new cc.Sequence(
            new cc.DelayTime(PaymentOverlay.SHOW_TIMEOUT / 1000),
            new cc.FadeIn(0.3)
        ));
    },

    // what the player reads while waiting: the store answered and our server is confirming beats the slow-store text,
    // the slow-store text appears before the close control so the reassurance comes before the exit
    refreshText: function () {
        if (this.terminated || this.cancelling) {
            return;
        }

        let key = "PaymentOverlay.waiting";
        if (connector.payments.getPurchaseState() === "validate") {
            key = "PaymentOverlay.validating";
        } else if (Date.now() - this.openedAt >= PaymentOverlay.SLOW_TIMEOUT) {
            key = "PaymentOverlay.slow";
        }

        if (this.textKey !== key) {
            this.textKey = key;
            this.text.setString(Messages.get(key));
            this.text.fitTo(this.textWidth);
        }
    },

    createCloseText: function () {
        const closeText = this.closeText = cleverapps.UI.generateOnlyText(Messages.get("PaymentOverlay.tapToClose"), cleverapps.styles.FONTS.PAYMENT_OVERLAY_CLOSE_TEXT);
        closeText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        this.addChild(closeText);

        closeText.setOpacity(0);
        closeText.setVisible(false);
        closeText.runAction(new cc.Sequence(
            new cc.DelayTime(PaymentOverlay.CLOSE_AVAILABLE / 1000),
            new cc.Show(),
            new cc.FadeIn(0.3)
        ));
    },

    startCancel: function () {
        this.cancelling = true;
        this.text.setString(Messages.get("PaymentOverlay.closing"));
        this.text.fitTo(this.textWidth);
        this.closeText.setVisible(false);

        // value: seconds the player waited before closing
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.PAYMENTS_TERMINATED, { value: Math.round((Date.now() - this.openedAt) / 1000) });

        this.showLoading();

        let delay = PaymentOverlay.CANCEL_DURATION / 1000;
        if (connector.payments.getPurchaseState() === "validate") {
            delay += 5;
        }

        this.runAction(new cc.Sequence(
            new cc.DelayTime(delay),
            new cc.CallFunc(() => {
                this.hideLoading();

                this.terminated = true;
                connector.payments.stopCurrentPurchase();
            })
        ));
    },

    onEnter: function () {
        this._super();

        console.log("PaymentsManager overlay created");
    },

    onExit: function () {
        this._super();

        console.log("PaymentsManager overlay closed");
    }
});

PaymentOverlay.initialize = function () {
    // the same on every store (2026-10-15: the close came after 4-15 seconds on most of them): at 30 seconds the text says the store
    // is slow and a paid purchase arrives by itself, at 60 seconds "tap to close" appears; the connector ends a silent store dialog
    // on its own after 3 minutes
    const showTimeout = "4 seconds";
    const slowTimeout = "30 seconds";
    const closeAvailable = "60 seconds";
    let cancelDuration = "10 seconds";

    if (connector.platform.oneOf(connector.IOS, connector.MACOS)) {
        cancelDuration = "20 seconds";
    }
    if (connector.payments.oneOf(connector.YOOKASSA)) {
        cancelDuration = "2 seconds";
    }
    if (connector.platform.oneOf(connector.DRAUGIEM)) {
        cancelDuration = "5 seconds";
    }

    PaymentOverlay.SHOW_TIMEOUT = cleverapps.parseInterval(showTimeout);
    PaymentOverlay.SLOW_TIMEOUT = cleverapps.parseInterval(slowTimeout);
    PaymentOverlay.CLOSE_AVAILABLE = cleverapps.parseInterval(closeAvailable);
    PaymentOverlay.CANCEL_DURATION = cleverapps.parseInterval(cancelDuration);
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PAYMENT_OVERLAY_TEXT: {
        size: 44,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    PAYMENT_OVERLAY_CLOSE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.PaymentOverlay = {
    text: {
        x: { align: "center" },
        y: { align: "bottom", dy: 110 },
        padding: 100
    },

    closeText: {
        x: { align: "center" },
        y: { align: "bottom", dy: 40 }
    }
};
